import {axios} from '../../../lib'

const getEndpointForEntity = (entity) => {
    switch (entity) {
        case "ARTICOL":
            return "/nomenclatures/omc/articles";
        case "PARTENER":
            return "/nomenclatures/omc/partners";
        case "CENTRU_DE_COST":
            return "/nomenclatures/omc/point-of-works";
        case "PUNCT_DE_LUCRU":
            return "/nomenclatures/omc/point-of-works";
        case "GRUPA_CHELTUIALA":
            return "/nomenclatures/omc/expense-groups";
        case "GRUPA_DOCUMENT":
            return "/nomenclatures/omc/document-groups";
        case "PROIECT":
            return "/nomenclatures/omc/projects";
        case "GRUPA_PARTENER":
            return "/api/grupa_partener/endpoint";
        default:
            return null;
    }
};

export const manuallySyncOMCEntity = (entity) => {
    const endpoint = getEndpointForEntity(entity);
    return axios.post(endpoint)
        .then((response) => {
            return {success: true, message: `${entity} sincronizare completă`};
        })
        .catch((error) => {
            console.error("Eroare API:", error);
            return {success: false, message: 'A apărut o problemă la efectuarea sincronizării'};
        });
};
